import Swal from "sweetalert2";
import store from "../../app/store/store";
import { ADDITEMS, GETITEMS, GETITEMSXLSX, UPDATEITEMS } from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const getItems = async ({ pagination, search, pageSize }) => {
  const { userDetail } = await store.getState().reducer;

  const res = await axios.post(GETITEMS, {
    myBusinessId: userDetail.myBusinessId,
    itemCategoryId: 0,
    isCounterSalesItem: true,
    page: pagination.page,
    pageSize: pageSize,
    filterByColumn: "",
    filterValue: "",
    searchByColumn: search ? "itemDescription" : "",
    searchValue: search || "",
    orderByColumn: "",
    orderBy: "",
  });
  return res;
};

export const getItemsXlsx = async ({ pagination, search, pageSize }) => {
  const { userDetail } = await store.getState().reducer;

 const res = await axios.post(
   GETITEMSXLSX,
   {
     myBusinessId: userDetail.myBusinessId,
     itemCategoryId: 0,
     isCounterSalesItem: true,
     page: pagination.page,
     pageSize: pageSize,
     filterByColumn: "",
     filterValue: "",
     searchByColumn: search ? "itemDescription" : "",
     searchValue: search || "",
     orderByColumn: "",
     orderBy: "",
   },
   {
     responseType: "blob", // ← This is the critical fix
   }
 );

  return res;
};

export const addItem = async (payload, isEdit) => {
  const { userDetail } = await store.getState().reducer;
  payload = { ...payload, MyBusinessId: userDetail.myBusinessId };

  const formDataobj = new FormData();
  Object.keys(payload).forEach((key) => {
    formDataobj.append(key, payload[key]);
  });

  console.log("payload obj add item ", payload);

  try {
    const res = await axios.post(isEdit ? UPDATEITEMS : ADDITEMS, formDataobj);

    if (res?.data?.succeeded) {
      Swal.fire({
        text: isEdit ? "Successfully Updated" : "Successfully Added",
        icon: "success",
        ...swalAlertPopProps,
      });
    } else {
      const errorMessage = res?.data?.message
        ?.toLowerCase()
        .includes("duplicate")
        ? "Duplicate names are not allowed. A service or product with this name already exists."
        : "Something went wrong";

      Swal.fire({
        text: errorMessage,
        icon: "warning",
        ...swalAlertPopProps,
      });
    }

    return res;
  } catch (error) {
    Swal.fire({
      text: "Server error. Please try again later.",
      icon: "error",
      ...swalAlertPopProps,
    });
    console.error("Error adding item:", error);
    return { data: { succeeded: false } };
  }
};

